/* eslint-disable import/first */
// Agent Dashboard
import _RecruitersManual from '../assets/images/recruiters_manual.svg';

export const RecruitersManual = _RecruitersManual;

import _Tutorials from '../assets/images/tutorials.svg';

export const Tutorials = _Tutorials;

import _MarketingMaterials from '../assets/images/marketing_materials.svg';

export const MarketingMaterials = _MarketingMaterials;

import _NewsCentre from '../assets/images/news_center.svg';

export const NewsCentre = _NewsCentre;

import _ProductUpdates from '../assets/images/product_updates.svg';

export const ProductUpdates = _ProductUpdates;

import _TermsAndConditions from '../assets/images/terms_and_conditions.svg';

export const TermsAndConditions = _TermsAndConditions;

import _Certificate from '../assets/images/certificate.svg';

export const Certificate = _Certificate;

import _InviteStudent from '../assets/images/invite_student.svg';

export const InviteStudent = _InviteStudent;

import _CommissionsInfo from '../assets/images/commissions_info.svg';

export const CommissionsInfo = _CommissionsInfo;

import _CalendarIcon from '../assets/images/calendar.svg';

export const CalendarIcon = _CalendarIcon;

import _CloseIcon from '../assets/images/x.svg';

export const CloseIcon = _CloseIcon;

import _CommissionsNoDataImage from '../assets/images/commissions_no-data.svg';

export const CommissionsNoDataImage = _CommissionsNoDataImage;

import _TopSchoolsNoDataImage from '../assets/images/top-schools_no-data.svg';

export const TopSchoolsNoDataImage = _TopSchoolsNoDataImage;

import _RecentProgramsNoDataImage from '../assets/images/recent-programs_no-data.svg';

export const RecentProgramsNoDataImage = _RecentProgramsNoDataImage;

// Agent profile page
import _InviteStudentsImage from '../assets/images/Invite_Students.svg';

export const InviteStudentsImage = _InviteStudentsImage;

// Use Credit / Filter / New Promotion / Promotions
import _Agent from '../assets/images/agents.svg';

export const Agent = _Agent;

import _Student from '../assets/images/student.svg';

export const Student = _Student;

// Invoice Panel
import _BanktransferIcon from '../assets/images/banktransfer_icon.svg';

export const BanktransferIcon = _BanktransferIcon;

import _Logo from '../assets/images/logo_invoice.svg';

export const Logo = _Logo;

// New Search Promotion / Search Header
import _PromoIcon from '../assets/images/new_search_promo.svg';

export const PromoIcon = _PromoIcon;

// ConstrainedToolTip
import _ERROR_OUTLINE from '../assets/images/custom_icons/search/error-outline.svg';

export const ERROR_OUTLINE = _ERROR_OUTLINE;

// Schools / Invite Students
import _HighSchoolImage from '../assets/images/High-School.png';

export const HighSchoolImage = _HighSchoolImage;

// New Agent (LoginRegisterModal.jsx)
import _HomeBackgroundImage from '../assets/images/home_background.jpg';

export const HomeBackgroundImage = _HomeBackgroundImage;

// New Agent (LoginRegisterModal.jsx)
import _Recruitment_PartnerImage from '../assets/images/Recruitment_Partner_Hero.png';

export const Recruitment_PartnerImage = _Recruitment_PartnerImage;

// // Slider / Dot.jsx
import _StartYoutubePlayImage from '../assets/images/9.png';

export const StartYoutubePlayImage = _StartYoutubePlayImage;

// // Slider / enhancer.js
import _YoutubeDefaultBackgroundImage from '../assets/images/youtube-default-background.jpg';

export const YoutubeDefaultBackgroundImage = _YoutubeDefaultBackgroundImage;

// constants.js
import _CAN_FLAG_IMPORTED from '../assets/images/canada_flag.png';

export const CAN_FLAG_IMPORTED = _CAN_FLAG_IMPORTED;

import _USA_FLAG_IMPORTED from '../assets/images/usa_flag.png';

export const USA_FLAG_IMPORTED = _USA_FLAG_IMPORTED;

// RP Email Error Icon
import _EMAIL_ERROR_ICON from '../assets/images/email_error_icon.svg';

export const EMAIL_ERROR_ICON = _EMAIL_ERROR_ICON;

// imageRefs.js
import _EDIT_BUTTON_IMPORTED from '../assets/images/custom_icons/requirements/edit.png';

export const EDIT_BUTTON_IMPORTED = _EDIT_BUTTON_IMPORTED;

import _FULFILL_DOCUMENT_IMPORTED from '../assets/images/custom_icons/requirements/Document.png';

export const FULFILL_DOCUMENT_IMPORTED = _FULFILL_DOCUMENT_IMPORTED;

import _FULFILL_PAYMENT_IMPORTED from '../assets/images/custom_icons/requirements/Payment.png';

export const FULFILL_PAYMENT_IMPORTED = _FULFILL_PAYMENT_IMPORTED;

import _FULFILL_QUESTIONS_IMPORTED from '../assets/images/custom_icons/requirements/Question.png';

export const FULFILL_QUESTIONS_IMPORTED = _FULFILL_QUESTIONS_IMPORTED;

import _REJECTION_NOTES_IMPORTED from '../assets/images/custom_icons/requirements/Comment.png';

export const REJECTION_NOTES_IMPORTED = _REJECTION_NOTES_IMPORTED;

import _ICON_INTERNAL_IMPORTED from '../assets/images/custom_icons/requirements/Internal.png';

export const ICON_INTERNAL_IMPORTED = _ICON_INTERNAL_IMPORTED;

import _ICON_APPLYBOARD_REQUIREMENT_IMPORTED from '../assets/images/custom_icons/requirements/ABRequirement.png';

export const ICON_APPLYBOARD_REQUIREMENT_IMPORTED = _ICON_APPLYBOARD_REQUIREMENT_IMPORTED;

import _ICON_ROBOT_IMPORTED from '../assets/images/custom_icons/requirements/Robot.svg';

export const ICON_ROBOT_IMPORTED = _ICON_ROBOT_IMPORTED;

import _ICON_MANUAL_IMPORTED from '../assets/images/custom_icons/requirements/Manual.png';

export const ICON_MANUAL_IMPORTED = _ICON_MANUAL_IMPORTED;

import _ICON_NOTARIZATION_IMPORTED from '../assets/images/custom_icons/requirements/Notarization.png';

export const ICON_NOTARIZATION_IMPORTED = _ICON_NOTARIZATION_IMPORTED;

import _ICON_MODIFIED_IMPORTED from '../assets/images/custom_icons/requirements/Modified.png';

export const ICON_MODIFIED_IMPORTED = _ICON_MODIFIED_IMPORTED;

import _RECEIPT_ICON from '../assets/images/custom_icons/requirements/ReceiptIcon.svg';

export const RECEIPT_ICON = _RECEIPT_ICON;

import _MISSING_ICON from '../assets/images/custom_icons/requirements/MissingIcon.png';

export const MISSING_ICON = _MISSING_ICON;

import _REVIEWING_ICON from '../assets/images/custom_icons/requirements/ReviewingIcon.png';

export const REVIEWING_ICON = _REVIEWING_ICON;

import _NOT_APPROVED_ICON from '../assets/images/custom_icons/requirements/NotApprovedIcon.png';

export const NOT_APPROVED_ICON = _NOT_APPROVED_ICON;

import _APPROVED_ICON from '../assets/images/custom_icons/requirements/ApprovedIcon.png';

export const APPROVED_ICON = _APPROVED_ICON;

import _APPLYBOARD_ICON from '../assets/images/applyboard-icon.svg';

export const APPLYBOARD_ICON = _APPLYBOARD_ICON;

// Student Dashboard
import _STUDENT_DASHBOARD_ACTION from '../assets/images/student-dashboard/action.svg';

export const STUDENT_DASHBOARD_ACTION = _STUDENT_DASHBOARD_ACTION;

import _STUDENT_DASHBOARD_ALL from '../assets/images/student-dashboard/all.svg';

export const STUDENT_DASHBOARD_ALL = _STUDENT_DASHBOARD_ALL;

import _STUDENT_DASHBOARD_ALL_NEW from '../assets/images/student-dashboard/all_new.svg';

export const STUDENT_DASHBOARD_ALL_NEW = _STUDENT_DASHBOARD_ALL_NEW;

import _STUDENT_DASHBOARD_BLOG from '../assets/images/student-dashboard/blog.svg';

export const STUDENT_DASHBOARD_BLOG = _STUDENT_DASHBOARD_BLOG;

import _STUDENT_DASHBOARD_CARET from '../assets/images/student-dashboard/caret.svg';

export const STUDENT_DASHBOARD_CARET = _STUDENT_DASHBOARD_CARET;

import _CARET_RIGHT from '../assets/images/caret_right.svg';

export const CARET_RIGHT = _CARET_RIGHT;

import _CARET_DOWN from '../assets/images/caret_down.svg';

export const CARET_DOWN = _CARET_DOWN;

import _STUDENT_DASHBOARD_HELP from '../assets/images/student-dashboard/help.svg';

export const STUDENT_DASHBOARD_HELP = _STUDENT_DASHBOARD_HELP;

import _STUDENT_DASHBOARD_HOW_IT_WORKS from '../assets/images/student-dashboard/how_it_works.svg';

export const STUDENT_DASHBOARD_HOW_IT_WORKS = _STUDENT_DASHBOARD_HOW_IT_WORKS;

import _STUDENT_DASHBOARD_NEGATIVE from '../assets/images/student-dashboard/negative.svg';

export const STUDENT_DASHBOARD_NEGATIVE = _STUDENT_DASHBOARD_NEGATIVE;

import _STUDENT_DASHBOARD_NEUTRAL from '../assets/images/student-dashboard/neutral.svg';

export const STUDENT_DASHBOARD_NEUTRAL = _STUDENT_DASHBOARD_NEUTRAL;

import _STUDENT_DASHBOARD_PLACEHOLDER_1 from '../assets/images/student-dashboard/placeholder1.png';

export const STUDENT_DASHBOARD_PLACEHOLDER_1 = _STUDENT_DASHBOARD_PLACEHOLDER_1;

import _STUDENT_DASHBOARD_PLACEHOLDER_2 from '../assets/images/student-dashboard/placeholder2.png';

export const STUDENT_DASHBOARD_PLACEHOLDER_2 = _STUDENT_DASHBOARD_PLACEHOLDER_2;

import _STUDENT_DASHBOARD_PLACEHOLDER_3 from '../assets/images/student-dashboard/placeholder3.png';

export const STUDENT_DASHBOARD_PLACEHOLDER_3 = _STUDENT_DASHBOARD_PLACEHOLDER_3;

import _STUDENT_DASHBOARD_PLACEHOLDER_4 from '../assets/images/student-dashboard/placeholder4.png';

export const STUDENT_DASHBOARD_PLACEHOLDER_4 = _STUDENT_DASHBOARD_PLACEHOLDER_4;

import _STUDENT_DASHBOARD_POSITIVE from '../assets/images/student-dashboard/positive.svg';

export const STUDENT_DASHBOARD_POSITIVE = _STUDENT_DASHBOARD_POSITIVE;

import _STUDENT_DASHBOARD_PROFILE from '../assets/images/student-dashboard/profile.svg';

export const STUDENT_DASHBOARD_PROFILE = _STUDENT_DASHBOARD_PROFILE;

import _STUDENT_DASHBOARD_SEARCH from '../assets/images/student-dashboard/search.svg';

export const STUDENT_DASHBOARD_SEARCH = _STUDENT_DASHBOARD_SEARCH;

import _STUDENT_DASHBOARD_STEP1 from '../assets/images/student-dashboard/step1.svg';

export const STUDENT_DASHBOARD_STEP1 = _STUDENT_DASHBOARD_STEP1;

import _STUDENT_DASHBOARD_STEP1_NEW from '../assets/images/student-dashboard/step1_new.svg';

export const STUDENT_DASHBOARD_STEP1_NEW = _STUDENT_DASHBOARD_STEP1_NEW;

import _STUDENT_DASHBOARD_STEP2 from '../assets/images/student-dashboard/step2.svg';

export const STUDENT_DASHBOARD_STEP2 = _STUDENT_DASHBOARD_STEP2;

import _STUDENT_DASHBOARD_STEP2_NEW from '../assets/images/student-dashboard/step2_new.svg';

export const STUDENT_DASHBOARD_STEP2_NEW = _STUDENT_DASHBOARD_STEP2_NEW;

import _STUDENT_DASHBOARD_STEP3 from '../assets/images/student-dashboard/step3.svg';

export const STUDENT_DASHBOARD_STEP3 = _STUDENT_DASHBOARD_STEP3;

import _STUDENT_DASHBOARD_STEP3_NEW from '../assets/images/student-dashboard/step3_new.svg';

export const STUDENT_DASHBOARD_STEP3_NEW = _STUDENT_DASHBOARD_STEP3_NEW;

import _STUDENT_DASHBOARD_STEP4 from '../assets/images/student-dashboard/step4.svg';

export const STUDENT_DASHBOARD_STEP4 = _STUDENT_DASHBOARD_STEP4;

import _STUDENT_DASHBOARD_STEP4_NEW from '../assets/images/student-dashboard/step4_new.svg';

export const STUDENT_DASHBOARD_STEP4_NEW = _STUDENT_DASHBOARD_STEP4_NEW;

import _STUDENT_DASHBOARD_STEP5 from '../assets/images/student-dashboard/step5.svg';

export const STUDENT_DASHBOARD_STEP5 = _STUDENT_DASHBOARD_STEP5;

import _STUDENT_DASHBOARD_STEP5_NEW from '../assets/images/student-dashboard/step5_new.svg';

export const STUDENT_DASHBOARD_STEP5_NEW = _STUDENT_DASHBOARD_STEP5_NEW;

import _REFUND_BUTTON_IMPORTED from '../assets/images/custom_icons/requirements/Credit.png';

export const REFUND_BUTTON_IMPORTED = _REFUND_BUTTON_IMPORTED;

import _APPLYPROOF_VERIFIED_ICON from '../assets/images/verify_icon.svg';

export const APPLYPROOF_VERIFIED_ICON = _APPLYPROOF_VERIFIED_ICON;

import _APPLYPROOF_ERROR_ICON from '../assets/images/applyproof_fail_icon.svg';

export const APPLYPROOF_ERROR_ICON = _APPLYPROOF_ERROR_ICON;

import _APPLYPROOF_INVALID_ICON from '../assets/images/applyproof_invalid.svg';

export const APPLYPROOF_INVALID_ICON = _APPLYPROOF_INVALID_ICON;

import _APPLICATION_STATUS from '../assets/images/custom_icons/student_records/Application_Status.svg';

export const APPLICATION_STATUS = _APPLICATION_STATUS;

import _APPLYPROOF_BADGE from '../assets/images/custom_icons/student_records/ApplyProof_Badge.svg';

export const APPLYPROOF_BADGE = _APPLYPROOF_BADGE;

import _APPLYPROOF_ICON from '../assets/images/custom_icons/student_records/ApplyProof_Icon.svg';

export const APPLYPROOF_ICON = _APPLYPROOF_ICON;

import _DOCUMENT_TYPE_ICON from '../assets/images/custom_icons/student_records/Document_Type_icon.svg';

export const DOCUMENT_TYPE_ICON = _DOCUMENT_TYPE_ICON;

import _DOWNLOAD_ICON from '../assets/images/custom_icons/student_records/Download_icon.svg';

export const DOWNLOAD_ICON = _DOWNLOAD_ICON;

import _PAYMENT_TYPE_ICON from '../assets/images/custom_icons/student_records/dollar-sign-solid.svg';

export const PAYMENT_TYPE_ICON = _PAYMENT_TYPE_ICON;

import _QUESTION_ANSWER_ICON from '../assets/images/custom_icons/student_records/Question_Answer_Icon.svg';

export const QUESTION_ANSWER_ICON = _QUESTION_ANSWER_ICON;

import _ROCKET_SHIP_ICON from '../assets/images/custom_icons/student_records/RocketShipIcon.png';

export const ROCKET_SHIP_ICON = _ROCKET_SHIP_ICON;

import _TIMELINE_RECENT_VIEW from '../assets/images/custom_icons/student_records/Timeline_Recent_view.svg';

export const TIMELINE_RECENT_VIEW = _TIMELINE_RECENT_VIEW;

import _TIMELINE_BULLET from '../assets/images/custom_icons/student_records/Timeline_bullet.svg';

export const TIMELINE_BULLET = _TIMELINE_BULLET;

import _STUDENT_RECORDS_ICON from '../assets/images/custom_icons/student_records/student_records_icon.svg';

export const STUDENT_RECORDS_ICON = _STUDENT_RECORDS_ICON;

import _STUDENT_RECORDS_ICON_WHITE from '../assets/images/custom_icons/student_records/student_records_icon_white.svg';

export const STUDENT_RECORDS_ICON_WHITE = _STUDENT_RECORDS_ICON_WHITE;

import _PREMIUM_USER from '../assets/images/premium_user.svg';

export const PREMIUM_USER = _PREMIUM_USER;

import _NON_PREMIUM_USER from '../assets/images/non_premium_user.svg';

export const NON_PREMIUM_USER = _NON_PREMIUM_USER;

import _PREMIUM_STAR from '../assets/images/premium_star.svg';

export const PREMIUM_STAR = _PREMIUM_STAR;

// GCS Modal
import _CHECK from '../assets/images/green_check.svg';

export const CHECK = _CHECK;

import _CLOSE from '../assets/images/close.svg';

export const CLOSE = _CLOSE;

// Header
import _BELL_OUTLINE from '../assets/images/custom_icons/header/bell-outline.svg';

export const BELL_OUTLINE = _BELL_OUTLINE;

import _SETTINGS_OUTLINE from '../assets/images/custom_icons/header/settings-outline.svg';

export const SETTINGS_OUTLINE = _SETTINGS_OUTLINE;

import _LOGOUT_OUTLINE from '../assets/images/custom_icons/header/logout-outline.svg';

export const LOGOUT_OUTLINE = _LOGOUT_OUTLINE;

import _DEFAULT_PROFILE_PICTURE from '../assets/images/custom_icons/header/default-profile-picture.svg';

export const DEFAULT_PROFILE_PICTURE = _DEFAULT_PROFILE_PICTURE;

// Footer
import _FOOTER_EMAIL from '../assets/images/footer/email.svg';

export const FOOTER_EMAIL = _FOOTER_EMAIL;

import _FOOTER_TWITTER from '../assets/images/footer/twitter.svg';

export const FOOTER_TWITTER = _FOOTER_TWITTER;

import _FOOTER_FACEBOOK from '../assets/images/footer/facebook.svg';

export const FOOTER_FACEBOOK = _FOOTER_FACEBOOK;

import _FOOTER_YOUTUBE from '../assets/images/footer/youtube.svg';

export const FOOTER_YOUTUBE = _FOOTER_YOUTUBE;

import _FOOTER_INSTAGRAM from '../assets/images/footer/instagram.svg';

export const FOOTER_INSTAGRAM = _FOOTER_INSTAGRAM;

import _FOOTER_LINKEDIN from '../assets/images/footer/linkedin.svg';

export const FOOTER_LINKEDIN = _FOOTER_LINKEDIN;

import _FULL_ERROR_PAGE from '../assets/images/full-error-page.svg';

export const FULL_ERROR_PAGE = _FULL_ERROR_PAGE;

import _WARNING_OUTLINE_YELLOW from '../assets/images/edit-students-tab/warning-outline-yellow.svg';

export const WARNING_OUTLINE_YELLOW = _WARNING_OUTLINE_YELLOW;

import _CHECKMARK from '../assets/images/checkmark.svg';

export const CHECKMARK = _CHECKMARK;

import _CREDIT_CARD from '../assets/images/credit_card.svg';

export const CREDIT_CARD = _CREDIT_CARD;

import _DASHBOARD_OUTLINE from '../assets/images/dashboard_outline.svg';

export const DASHBOARD_OUTLINE = _DASHBOARD_OUTLINE;

import _EDIT_OUTLINE from '../assets/images/edit_outline.svg';

export const EDIT_OUTLINE = _EDIT_OUTLINE;

import _MAGNIFYING_GLASS from '../assets/images/magnifying_glass.svg';

export const MAGNIFYING_GLASS = _MAGNIFYING_GLASS;

import _PERSON_OUTLINE from '../assets/images/person_outline.svg';

export const PERSON_OUTLINE = _PERSON_OUTLINE;

import _WARNING_SIGN from '../assets/images/warning_sign.svg';

export const WARNING_SIGN = _WARNING_SIGN;

// Welcome Lead Management Modal
import _Leads from '../assets/images/welcome-lead-management-modal/leads.svg';
import _DragAndDrop from '../assets/images/welcome-lead-management-modal/dragAndDrop.svg';
import _StudentSummary from '../assets/images/welcome-lead-management-modal/studentSummary.svg';

export const Leads = _Leads;
export const DragAndDrop = _DragAndDrop;
export const StudentSummary = _StudentSummary;

// Visa Probability
import _Megaphone from '../assets/images/visa-probability/megaphone.svg';
import _Scale from '../assets/images/visa-probability/scale.svg';
import _People_Immigration from '../assets/images/visa-probability/people_immigration.svg';
import _Calculator from '../assets/images/visa-probability/calculator.svg';

export const Megaphone = _Megaphone;
export const Scale = _Scale;
export const People_Immigration = _People_Immigration;
export const Calculator = _Calculator;
